export const QUERY_KEYS = {
  User: ['user'] as const,
  OrganizationMembers: (params: {
    organizationId: string | null;
    [key: string]: string | number | boolean | null | undefined;
  }) => ['organizationMembers', params] as const,
  FeatureFlags: (params: { organizationId: string | null }) => ['featureFlags', params] as const,
  ClientAccountNames: (params: { organizationId: string | null }) => ['clientAccountNames', params] as const,
  ClientAccountSearch: (params: { organizationId: string | null; search: string }) =>
    ['clientAccountSearch', params] as const,
  ClientAccounts: (params: {
    organizationId: string | null;
    [key: string]: string | number | boolean | null | undefined;
  }) => ['clientAccounts', params] as const,
  ClientAccount: (params: { organizationId: string | null; clientAccountId: string | null }) =>
    ['clientAccount', params] as const,
  ClientAccountJobs: (params: { organizationId: string | null; clientAccountId: string | null }) =>
    ['clientAccountJobs', params] as const,
  ClientAccountJob: (params: { organizationId: string | null; jobId: string | null }) =>
    ['clientAccountJob', params] as const,
  ClientAccountJobSections: (params: { organizationId: string | null; jobId: string | null }) =>
    ['clientAccountJobSections', params] as const,
  JobTypes: (params: { organizationId: string | null; includeArchived?: boolean }) => ['jobTypes', params] as const,
  ClientTeamRoles: (params: { organizationId: string | null }) => ['clientTeamRoles', params] as const,
  ClientTeamRoleDeleteImpact: (params: { organizationId: string | null; roleId: string | null }) =>
    ['clientTeamRoleDeleteImpact', params] as const,
  ClientStorageFiles: (params: { organizationId: string | null; clientAccountId: string | null; basePath: string }) =>
    ['clientStorageFiles', params] as const,
  Contacts: (params: { organizationId: string | null; [key: string]: string | number | boolean | null | undefined }) =>
    ['contacts', params] as const,
  Contact: (params: { organizationId: string | null; contactId: string | null }) => ['contact', params] as const,
  ContactTypes: (params: { organizationId: string | null }) => ['contactTypes', params] as const,
  ContactSearch: (params: { organizationId: string | null; search: string }) => ['contactSearch', params] as const,
  RfiTemplates: (params: { organizationId: string | null }) => ['rfiTemplates', params] as const,
  RfiTemplate: (params: { organizationId: string | null; templateId: string | null }) =>
    ['rfiTemplate', params] as const,
  ClientInbox: (params: { organizationId: string | null; clientAccountId: string | null }) =>
    ['clientInbox', params] as const,
  ClientInboxThread: (params: { organizationId: string | null; clientAccountId: string | null; threadId: string }) =>
    ['clientInboxThread', params] as const,
} as const;
